import { ApiError } from '../../types/api';

export class ApiErrorHandler {
  static handle(error: any): ApiError {
    if (error.response) {
      // Server responded with a status code outside the 2xx range
      return {
        message: error.response.data.message || 'An error occurred',
        code: error.response.data.code || 'UNKNOWN_ERROR',
        status: error.response.status,
        details: error.response.data.details
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        message: 'No response received from server',
        code: 'NETWORK_ERROR',
        status: 0
      };
    } else {
      // Something happened in setting up the request
      return {
        message: error.message || 'An unexpected error occurred',
        code: 'REQUEST_SETUP_ERROR',
        status: 0
      };
    }
  }
}